import React, { useState, useEffect } from "react";
import { GoArrowDownRight } from "react-icons/go";
import { FaRegHandshake, FaMoneyBillWave, FaRoute, FaClock, FaArrowAltCircleRight } from "react-icons/fa";

const DriverOpportunity = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [Data, setData] = useState([]);

  const toggleAccordion = (index) => setOpenIndex(openIndex === index ? null : index);

  const GetData = async () => {
    try {
      const api = await fetch("https://pegiora.com/dashboard12/api/deliveries?send_by=Officialpegiora", {
        method: "POST",
      });
      const res = await api.json();
      console.log(res, "res data");
      setData(res.data || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    GetData();
    const interval = setInterval(GetData, 60000 * 3);
    return () => clearInterval(interval);
  }, []);

  const opportunities = [
    {
      id: 1,
      title: "Flexible Work Schedule",
      desc: "Drive whenever you want — full-time or part-time, the choice is yours.",
      icon: <FaClock style={{ color: "#4F46E5", fontSize: "30px", marginBottom: "10px" }} />,
    },
    {
      id: 2,
      title: "High Earnings Potential",
      desc: "Earn competitive payouts per delivery, plus bonuses for top performance.",
      icon: <FaMoneyBillWave style={{ color: "#4F46E5", fontSize: "30px", marginBottom: "10px" }} />,
    },
    {
      id: 3,
      title: "Route Freedom",
      desc: "Choose your delivery routes and accept only the jobs that suit you.",
      icon: <FaRoute style={{ color: "#4F46E5", fontSize: "30px", marginBottom: "10px" }} />,
    },
    {
      id: 4,
      title: "Be Part of a Growing Network",
      desc: "Join a trusted logistics community that’s expanding across the nation.",
      icon: <FaRegHandshake style={{ color: "#4F46E5", fontSize: "30px", marginBottom: "10px" }} />,
    },
  ];

  const faqs = [
    {
      question: "How do I join Pegiora as a driver?",
      answer:
        "Simply download our app from the Play Store and complete your registration. You’ll start receiving delivery requests once verified.",
    },
    {
      question: "Do I need a commercial license?",
      answer:
        "No, a valid personal driver’s license is enough for most delivery categories.",
    },
    {
      question: "How are drivers paid?",
      answer:
        "Payments are processed weekly via direct bank transfer or digital wallet options available in the Pegiora Driver App.",
    },
  ];

  return (
    <div style={{ backgroundColor: "#f9fafb", color: "#1f2937", fontFamily: "Arial, sans-serif" }}>
      {/* Hero Section */}
      <section
        style={{
          backgroundImage: "url('/image/banner.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          textAlign: "center",
          color: "white",
          padding: "80px 20px",
          position: "relative",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            padding: "80px 20px",
            borderRadius: "10px",
          }}
        >
          <img
            src="/image/car.gif"
            alt="Driver"
            style={{ height: "80px", marginBottom: "20px", opacity: "0.9" }}
          />
          <h1 style={{ fontSize: "40px", fontWeight: "bold", marginBottom: "15px" }}>
            Drive with Pegiora
          </h1>
          <p
            style={{
              fontSize: "18px",
              color: "#e5e7eb",
              maxWidth: "600px",
              margin: "0 auto 30px auto",
              lineHeight: "1.6",
            }}
          >
            Turn your vehicle into an opportunity. Earn more by delivering packages safely and efficiently.
          </p>
          <a
            href="https://play.google.com/store/apps/details?id=com.redixpress"
            style={{
              display: "inline-block",
              padding: "12px 30px",
              backgroundColor: "#4F46E5",
              color: "#fff",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            Register as a Driver
          </a>
        </div>
      </section>

      {/* 🚚 Live Deliveries Table Section */}
      <section style={{ padding: "60px 20px", maxWidth: "1200px", margin: "0 auto" }}>
        <h2 style={{ fontSize: "26px", fontWeight: "600", textAlign: "center", marginBottom: "20px" }}>
          Live Delivery Opportunities
        </h2>

        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              backgroundColor: "#fff",
              borderRadius: "8px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              overflow: "hidden",
            }}
          >
            <thead style={{ backgroundColor: "#4F46E5", color: "#fff" }}>
              <tr>
                <th style={{ padding: "12px" }}>#</th>
                <th style={{ padding: "12px", textAlign: "center" }}>Pickup Address</th>
                <th style={{ padding: "12px", textAlign: "left" }}></th>
                <th style={{ padding: "12px", textAlign: "center" }}>Delivery Address</th>
                {/* <th style={{ padding: "12px", textAlign: "left" }}>Status</th>
                <th style={{ padding: "12px", textAlign: "left" }}>Date</th> */}
              </tr>
            </thead>
            <tbody>
              {Data && Data.length > 0 ? (
                Data.map((ele, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #e5e7eb",
                      backgroundColor: index % 2 === 0 ? "#f9fafb" : "#fff",
                    }}
                  >
                    <td style={{ padding: "10px", textAlign: "center" }}>{index + 1}</td>
                    <td style={{ padding: "10px" }}>{ele?.address?.address || "N/A"}</td>
                    <td style={{ padding: "10px" }}><FaArrowAltCircleRight /> </td>
                    <td style={{ padding: "10px" }}>{ele?.recipient_address || "N/A"}</td>
                    {/* <td
                      style={{
                        padding: "10px",
                        fontWeight: "bold",
                        color:
                          ele?.status === "Delivered"
                            ? "green"
                            : ele?.status === "Pending"
                            ? "orange"
                            : "red",
                      }}
                    >
                      {ele?.status || "Pending"}
                    </td>
                    <td style={{ padding: "10px" }}>
                      {ele?.created_at ? new Date(ele.created_at).toLocaleString() : "—"}
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "#6b7280" }}>
                    No deliveries available right now.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* Opportunities Section */}
      <section style={{ padding: "70px 20px", maxWidth: "1200px", margin: "0 auto" }}>
        <h2
          style={{
            fontSize: "28px",
            fontWeight: "600",
            textAlign: "center",
            marginBottom: "10px",
          }}
        >
          Why Join Our Driver Network?
        </h2>
        <p
          style={{
            textAlign: "center",
            color: "#6b7280",
            fontSize: "16px",
            marginBottom: "40px",
          }}
        >
          Pegiora offers flexible, high-reward delivery opportunities designed for individuals who value freedom and reliability.
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "25px",
          }}
        >
          {opportunities.map((op) => (
            <div
              key={op.id}
              style={{
                backgroundColor: "#fff",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                borderRadius: "12px",
                padding: "25px",
                textAlign: "center",
                transition: "0.3s",
              }}
            >
              {op.icon}
              <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "10px" }}>{op.title}</h3>
              <p style={{ color: "#6b7280", fontSize: "14px" }}>{op.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* App Promo Section */}
      <section
        style={{
          backgroundColor: "#EEF2FF",
          textAlign: "center",
          padding: "70px 20px",
        }}
      >
        <h2 style={{ fontSize: "24px", fontWeight: "600", marginBottom: "10px" }}>
          Get Started in Just a Few Steps
        </h2>
        <p style={{ color: "#4b5563", marginBottom: "30px" }}>
          Download the Pegiora Driver App to start earning today.
        </p>
        <a
          href="https://play.google.com/store/apps/details?id=com.redixpress"
          style={{
            backgroundColor: "#4F46E5",
            color: "#fff",
            padding: "12px 30px",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          Download Now
        </a>
      </section>

      {/* FAQ Section */}
      <section style={{ padding: "70px 20px", maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "30px" }}>
          <div style={{ flex: "1 1 40%" }}>
            <h5 style={{ color: "#4F46E5", fontWeight: "bold" }}>
              FAQ <GoArrowDownRight />
            </h5>
            <h2 style={{ fontSize: "24px", marginTop: "10px" }}>
              You’ve Got Questions, We’ve Got Answers
            </h2>
            <p style={{ color: "#6b7280", marginTop: "10px" }}>
              Everything you need to know about driving with Pegiora — clear,
              quick, and to the point.
            </p>
          </div>

          <div style={{ flex: "1 1 55%" }}>
            {faqs.map((faq, index) => (
              <div key={index} style={{ marginBottom: "15px" }}>
                <button
                  style={{
                    width: "100%",
                    backgroundColor: openIndex === index ? "#EEF2FF" : "#fff",
                    border: "1px solid #d1d5db",
                    padding: "12px 15px",
                    borderRadius: "6px",
                    textAlign: "left",
                    fontWeight: "bold",
                    cursor: "pointer",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                  onClick={() => toggleAccordion(index)}
                >
                  {faq.question}
                  <span>{openIndex === index ? "−" : "+"}</span>
                </button>
                {openIndex === index && (
                  <div
                    style={{
                      padding: "10px 15px",
                      backgroundColor: "#f9fafb",
                      borderLeft: "3px solid #4F46E5",
                    }}
                  >
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DriverOpportunity;
